import React from 'react';
import { IValueRow } from './interface';
import { styled, TableCell, TableRow, Typography } from '@mui/material';

export const ValueRow: React.FC<IValueRow> = ({
  label,
  value,
  children,
  width = '50px',
  verticalAlign = 'middle',
}): JSX.Element => {
  const TableCellHeading = styled(TableCell)(() => ({
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  }));

  return (
    <TableRow>
      <TableCellHeading width={width} sx={{ verticalAlign: verticalAlign }}>
        {label}
      </TableCellHeading>
      {children && (
        <TableCell
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {children}
        </TableCell>
      )}
      {!children && (
        <TableCell>
          <Typography variant="body2">{value || '-'}</Typography>
        </TableCell>
      )}
    </TableRow>
  );
};
